import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import LandingPage from "./pages/LandingPage";
import Home from "./pages/Home";
import ProfilePage from "./pages/ProfilePage";
import Viewone from "./pages/Viewone";
import Viewtwo from "./pages/Viewtwo";
import Viewthree from "./pages/Viewthree";
import Viewfour from "./pages/Viewfour";
import VisitingCard from "./pages/VisitingCard";
import EditCard from "./pages/EditCard";
import NotFound from "./pages/NotFound";
import ContactPage from "./pages/ContactPage";
import ThemesPage from "./pages/ThemesPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import AllAnalyticsPage from "./pages/AllAnalyticsPage";
import TrafficPage from "./pages/TrafficPage";
import CardAnimationPage from "./pages/CardAnimationPage";
import WalletAnimationPage from "./pages/WalletAnimationPage";
import PaymentSuccess from "./pages/PaymentSuccess";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Named routes first — order matters */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/themes" element={<ThemesPage />} />
          <Route path="/viewone" element={<Viewone />} />
          <Route path="/viewtwo" element={<Viewtwo />} />
          <Route path="/viewthree" element={<Viewthree />} />
          <Route path="/viewfour" element={<Viewfour />} />
          <Route path="/create" element={<Home />} />
          <Route path="/animation/card" element={<CardAnimationPage />} />
          <Route path="/animation/wallet" element={<WalletAnimationPage />} />
          <Route path="/card/:id" element={<ProfilePage />} />
          <Route path="/ProfileCard/:id" element={<ProfilePage />} />
          <Route path="/edit/:id" element={<EditCard />} />
          <Route path="/analytics" element={<AllAnalyticsPage />} />
          <Route path="/analytics/:id" element={<AnalyticsPage />} />
          <Route path="/analytics/:id/traffic" element={<TrafficPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />

          {/* Short public card URL — must be before catch-all */}
          <Route path="/:id" element={<VisitingCard />} />

          {/* 404 — catch everything else */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
